import React from "react";
import { Navigate, useParams } from "react-router-dom";

function Redirect() {
    const {businessHashId} = useParams();
    return (
        <Navigate to={`/customer-verify/${businessHashId}`} />
    )
}

export default Redirect;